<script setup lang="ts">
import UIToolTip from '@/components/ui/UIToolTip.vue'
import useLanguage from '@/composables/useLanguage'
import { TTooltipAlignment, TTooltipDirection } from '@lifk/types'
import { PhStar } from '@phosphor-icons/vue'
import { ref } from 'vue'

withDefaults(
  defineProps<{
    colorClass?: string
    activeColorClass?: string
    size?: number
    active?: boolean
    label: string
    tooltipDirection?: TTooltipDirection
    tooltipAlignment?: TTooltipAlignment
  }>(),
  {
    colorClass: 'fill-slate-tint-1',
    activeColorClass: 'fill-poppy',
    size: 14,
    active: false,
    tooltipDirection: 'top',
    tooltipAlignment: 'center'
  }
)

const i18n = useLanguage('UIStarIcon')

const hovered = ref(false)
</script>

<template>
  <UIToolTip
    class="flex"
    :direction="tooltipDirection"
    :alignment="tooltipAlignment"
    :text="i18n.pin"
  >
    <button
      class="flex-shrink-0"
      tabindex="0"
      :aria-label="label"
      :aria-pressed="active"
      @mouseover="hovered = true"
      @mouseleave="hovered = false"
    >
      <PhStar
        :size="size"
        :class="active ? activeColorClass : colorClass"
        :weight="hovered || active ? 'fill' : 'regular'"
      />
    </button>
  </UIToolTip>
</template>
